/*
  Dark/light homepage rotation (per visit).
  snippets/understory-ab-assign.liquid puts the visitor's arm on <html data-ab-theme>. This file copies
  that arm onto the cart as the attribute "ab_theme", which Shopify carries onto the order, so orders can
  be counted per arm (Orders > Additional details, or the "Note Attributes" column of an order export).
  Because each visit is a random 50/50 pick, comparing order counts between designs is a fair comparison.
  Known gap: express checkout buttons on the product page (Shop Pay, Buy it now) skip the cart, so those
  orders arrive without the attribute.
*/
const UNDERSTORY_AB_ATTRIBUTE = 'ab_theme';

(() => {
  const variant = document.documentElement.getAttribute('data-ab-theme');
  if (variant !== 'light' && variant !== 'dark') return;

  const routes = window.routes || {};
  const cartUrl = (routes.cart_url || '/cart') + '.js';
  const updateUrl = (routes.cart_update_url || '/cart/update') + '.js';
  let inFlight = null;

  const tagCart = () => {
    if (inFlight) return inFlight;
    inFlight = fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const current = cart.attributes ? cart.attributes[UNDERSTORY_AB_ATTRIBUTE] : undefined;
        if (!cart.item_count || current === variant) return;
        return fetch(updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [UNDERSTORY_AB_ATTRIBUTE]: variant } }),
        });
      })
      .catch((e) => console.error(e))
      .finally(() => {
        inFlight = null;
      });
    return inFlight;
  };

  // Tag after every cart change (add, quantity, drawer), and once on load for carts started earlier.
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, tagCart);
    }
    if (/(?:^|; )cart=/.test(document.cookie)) tagCart();
  });

  // Checkout reads the cart as it stands, so make sure the attribute is on it before leaving.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\b/.test(form.getAttribute('action') || '')) return;
      // Dawn's checkout buttons sit outside their form (form="..."), so check the submitter, not children.
      if (!event.submitter || event.submitter.name !== 'checkout') return;
      const attribute = form.querySelector('input[name="attributes[' + UNDERSTORY_AB_ATTRIBUTE + ']"]');
      if (attribute) {
        attribute.value = variant;
        return;
      }
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + UNDERSTORY_AB_ATTRIBUTE + ']';
      input.value = variant;
      form.appendChild(input);
    },
    true
  );
})();
